// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPrimaryImageStyles } from "@tps/Overrides/Components/ProductPrimaryImage";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            height: auto;
            max-width: 100%;
        }
    `,
};
productPrimaryImageStyles.zoomBtn = {
    css: css`
        position: absolute;
        bottom: 8px;
        right: 8px;
        z-index: 1;
        padding: 0;
        height: 16px;
        width: 16px;
        &&&& svg {
            width: 14px;
            height: 16px;
        }
    `,
};
productPrimaryImageStyles.container = {
    css: css`
        position: relative;
    `,
};
